export default (actionName) => ({
    LOADING: `LOADING_${actionName}`,
    START: `START_${actionName}`,
    SUCCESS: `SUCCESS_${actionName}`,
    ERROR: `ERROR_${actionName}`,
    CACHE: `CACHE_${actionName}`,
    COMPLETE: `COMPLETE_${actionName}`,
});
